import React from 'react';

export default function ImpactCard({ title, description, icon }) {
  return (
    <div className="ps-card ps-impact-card">
      {icon && <div className="ps-impact-icon">{icon}</div>}
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}
